export default __webpack_public_path__ + "static/media/star_full.ab63b417.svg";